<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">{{ label }}</div>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model.trim="v.lastName.$model"
          :errorMessages="getValidationErrorText(v.lastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.firstName.$model"
          :errorMessages="getValidationErrorText(v.firstName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model.trim="v.patronymic.$model"
          :errorMessages="getValidationErrorText(v.patronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.snils.$model"
          :errorMessages="getValidationErrorText(v.snils)"
          :label="FieldLabel.SNILS"
          v-mask="Mask.SNILS"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          :label="FieldLabel.INN"
          v-mask="Mask.INN"
          outlined
        />
      </v-col>

      <v-col cols="6">
        <v-text-field
          v-model="v.status.$model"
          :errorMessages="getValidationErrorText(v.status)"
          label="Должность или статус представителя"
          outlined
        />
      </v-col>
    </v-row>

    <StatusDocument :v="v.documents.statusDocument" />

    <v-row>
      <v-col cols="3">
        <v-text-field
          v-model="v.email.$model"
          :errorMessages="getValidationErrorText(v.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="v.phone.$model"
          :errorMessages="getValidationErrorText(v.phone)"
          v-mask="['+7 ### ###-##-##']"
          label="Контактный телефон"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import {
  EMAIL,
  EMOJI,
  getValidationErrorText,
  INN,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  MinLength,
  PERSON_NAME,
} from '@/utils/validate';
import { DocumentType } from '@/types/services';
import { FieldLabel, FieldName, Mask } from '@/constants';
import StatusDocument, {
  getStatusDocumentValidation,
  statusDocumentModel,
} from '@/components/services/elements/StatusDocument';
import cloneDeep from 'clone-deep';
import { AuthModule } from '@/store/modules/auth';
import deepmerge from 'deepmerge';

export const getAssigneeValidation = (assignee) => {
  return {
    lastName: {
      required,
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    firstName: {
      required,
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    patronymic: {
      maxLength: maxLength(MAX_LENGTH),
      PERSON_NAME,
    },
    snils: {
      required,
      minLength: minLength(MinLength.SNILS),
    },
    inn: {
      minLength: minLength(12),
      required,
      INN: INN(12),
    },
    status: {
      maxLength: maxLength(1000),
      EMOJI,
      required,
    },
    email: {
      required,
      EMAIL,
      maxLength: maxLength(MAX_LENGTH_EMAIL),
    },
    phone: {
      required,
      minLength: minLength(16),
    },
    documents: {
      statusDocument: deepmerge(getStatusDocumentValidation(assignee, true), {
        name: {
          required,
        },
        docDate: {
          required,
        },
        issuer: {
          required,
        },
        number: {
          required,
        },
      }),
    },
  };
};

export const assigneeModel = {
  lastName: '',
  firstName: '',
  patronymic: '',
  snils: '',
  inn: '',
  status: '',
  email: '',
  phone: '',
  documents: {
    statusDocument: cloneDeep(statusDocumentModel),
  },
};

export const prefillEsiaAssignee = async () => {
  const esiaPerson = await AuthModule.getPerson();
  const assignee = {};

  Object.keys(assigneeModel).forEach((fieldName) => {
    assignee[fieldName] = esiaPerson[fieldName] ?? assigneeModel[fieldName];
  });

  return cloneDeep(assignee);
};

export default {
  name: 'Assignee',
  components: {
    StatusDocument,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
    DocumentType,
    Mask,
    FieldName,
    FieldLabel,
  }),
};
</script>
